import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SelectItem } from "@/components/ui/select";

export const baseClass = (c) => (c || "").split(/\s+-\s+|-\(/)[0].trim();

export function useClassOptions(branchId, extra = []) {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/student-classes", { params: { branch_id: branchId && branchId !== "all" ? branchId : undefined } }).then((r) => setList(r.data)).catch(() => setList([]));
  }, [branchId]);
  const all = Array.from(new Set([...extra, ...list]));
  const groups = Array.from(new Set(all.map(baseClass))).filter((b) => b && all.some((c) => baseClass(c) === b && c !== b));
  return { groups, all: all.filter((c) => !groups.includes(c)) };
}

export function ClassOptionItems({ opts }) {
  return (
    <>
      {opts.groups.map((g) => <SelectItem key={`g-${g}`} value={g}>{g} (all batches)</SelectItem>)}
      {opts.all.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
    </>
  );
}
